import { isMobile } from 'mobile-device-detect'

export default function () {
  this.doLoad()

  if (isMobile) {
    this.isMobiled = true
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/dashboard/gadget/resources/mounted.js